<template>
    <app-tabela
        :itens="eventosLista"
        :campos="campos"
        :itensPorPagina="itensPorPagina"
        :mostrarFiltro="false"
        :bordered="false"
        :small="false">
        <template slot="nomeEvento" slot-scope="data">
            {{data.nomeEvento }}
        </template>
        <template slot="situacao" slot-scope="data">
            <app-status
                :status="data.situacao.toUpperCase()"
            ></app-status>
        </template>
        <template slot="botoes">
            <slot name="botoes"></slot>
        </template>
        <template slot="acoes" slot-scope="data">
            <!-- <btn-atualizar-evento
                :tipo="operacao"
                :acao="acao"
                :evento="data"
                @atualizarLista="atualizarEventos()"
            ></btn-atualizar-evento>
            <btn-cancelar-evento
                :evento="data"
                :acao="acao"
                @atualizarLista="atualizarEventos()">
            </btn-cancelar-evento> -->
            <documentos-evento
                v-if="$temAcessoView('CONV-EVENTO-03')"
                :evento="data"
                @atualizarLista="atualizarEventos()">
            </documentos-evento>
            <metas-evento
                :evento="data"
                :acao="acao"
                @atualizarLista="atualizarEventos()">
            </metas-evento>
            <slot name="acoes" v-bind="data"></slot>
        </template>
    </app-tabela>
</template>

<script>
import BtnAtualizarEvento from './BtnAtualizarEvento'
import BtnCancelarEvento from './BtnCancelarEvento'
import DocumentosEvento from './DocumentosEvento'
import ConveniosServicos from '../../../ConveniosServicos'
import MetasEvento from './metas/MetasEvento'

export default {
    components: {
        BtnAtualizarEvento,
        BtnCancelarEvento,
        DocumentosEvento,
        MetasEvento
    },

    props: {
        eventos: {
            type: Array,
            default: () => []
        },

        operacao: {
            type: String,
            default: () => 'D'
        },

        acao: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'nomeEvento',
                    label: 'Nome do Evento',
                    sortable: true,
                    filterable: true
                },
                {
                key: 'situacao',
                label: 'Situação',
                filterable: true,
                sortable: true,
                tdClass: 'text-nowrap'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5,
            eventosLista: []
        }
    },

    methods: {
        atualizarEventos() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterEventosPorAcao(
                this.acao.idAcaoPlanoTrabalho)
                .then(response => {
                if (response) {
                    if (response.success) {
                        this.eventosLista = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter os eventos da ação.',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    mounted(){
        if(this.eventos){
            this.eventosLista = this.eventos
        }
    },

    watch: {
        eventos() {
            this.eventosLista = this.eventos
        }
    }
}
</script>
